<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestra Gran Vía</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              De Madrid te gusta todo, pero si solo pudieras elegir un punto clave de la ciudad, ¿cuál sería? ¿La Puerta
              del Sol, el Palacio Real, la Castellana, la Plaza Mayor,…? Desde nuestro punto de vista, la Gran Vía es el
              lugar que mejor representa a Madrid, y estar en la ciudad y no pasearla de arriba abajo es casi un crimen.
              Pues lo mismo ocurre con estos puntos de la Sierra Norte de Madrid que hemos seleccionado para ti, para
              que
              <strong
                >si tienes poco tiempo para visitarnos al menos conozcas nuestros enclaves imprescindibles.</strong
              >
            </p>
          </div>
          <!--          <div class="col-12 mt-4">-->
          <!--            <img src="/img/icons/familias.svg" alt="Planes especiales para familias" class="mr-3" /><img-->
          <!--              src="/img/icons/parejas.svg"-->
          <!--              alt="Planes especiales para parejas"-->
          <!--              class="mr-3"-->
          <!--            /><span class="text-black small">Planes para todos</span>-->
          <!--          </div>-->
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Nuestra esencia: naturaleza y ruralidad</h2>
            <p class="subtitular z-index-up">
              Pueblos con encanto, el murmullo de un río cercano, un horizonte perfilado por las montañas…
              <strong
                >La Sierra Norte de Madrid es todo lo que nunca hubieras creído encontrar tan cerca de la capital:
                naturaleza agreste, fauna salvaje, casitas de cuento y mucho silencio.</strong
              >
              Sin duda, es “otro Madrid”. ¿Vienes a conocerlo?
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta8/patones-de-arriba.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3 d-flex align-items-center">
                  <span>Patones de Arriba</span
                  ><img class="ml-3" src="/img/logos/villas-de-madrid.png" alt="Villas de Madrid" />
                </h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/de-la-arquitectura-a-la-mesa/"
                        target="_blank"
                        alt="Más información sobre Patones de Arriba"
                        >¡Uno de los pueblos más pintorescos de la Comunidad de Madrid!</a
                      >
                      Todas las casas del pueblo están hechas de piedra, por lo que es un
                      <strong>fiel representante de la arquitectura típica local.</strong>
                    </span>
                  </li>
                  <li>
                    <span> Si tienes tiempo puedes visitar <strong>La presa del Pontón de la Oliva.</strong> </span>
                  </li>
                  <li>
                    <span>
                      Consejos adicionales: Si quieres ir a verlo en fin de semana o festivo, reserva antes en algún
                      restaurante para comer, porque suelen llenarse; No está permitido aparcar en Patones de Arriba.
                      Puedes hacerlo en Patones de Abajo y subir caminando por la Senda del Barranco. ¡Solo te llevará
                      10 o 15 minutos de agradable paseo!
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-5h" />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3 d-flex align-items-center">
                  <span>Patones de Arriba</span>
                  <img
                    class="ml-3"
                    src="/img/logos/logo-villas-de-madrid-circular.png"
                    alt="Villas de Madrid"
                    width="60px"
                  />
                </h3>

                <p>
                  ¿Buscas arquitectura y gastronomía tradicionales? ¡Patones de Arriba te conquistará!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-5h" />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta8/buitrago-de-lozoya.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3 d-flex align-items-center">
                  <span>Buitrago del Lozoya</span>
                  <img
                    class="ml-3"
                    src="/img/logos/logo-villas-de-madrid-circular.png"
                    alt="Villas de Madrid"
                    width="60px"
                  />
                </h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/planes/visitas-buitrago"
                        target="_blank"
                        alt="Más información sobre Buitrago de Lozaya"
                        >Buitrago</a
                      >
                      se alza sobre un promontorio circundado por el río Lozoya, del que toma parte de su nombre, y
                      <strong>destaca por la muralla que rodea su centro histórico.</strong> Además, su Castillo o
                      Alcázar, la iglesia de Santa María del Castillo, la Torre del Reloj y la propia muralla te
                      trasladarán hasta la Edad Media.
                    </span>
                  </li>
                  <li>
                    <span>
                      ¿Sabías que en Buitrago del Lozoya puedes visitar un
                      <strong>museo dedicado a Pablo Picasso,</strong> con 65 obras del pintor malagueño?
                    </span>
                  </li>

                  <li>
                    <span>
                      Muy cerca de Buitrago puedes disfrutar de un entorno natural privilegiado: ¿has visitado ya las
                      <strong>piscinas naturales de Riosequillo?</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejo adicional: es posible llegar en transporte público (autobús desde Plaza Castilla. Línea
                      191).
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="6h" />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3 d-flex align-items-center">
                  <span>Buitrago del Lozoya</span>
                  <img
                    class="ml-3"
                    src="/img/logos/logo-villas-de-madrid-circular.png"
                    alt="Villas de Madrid"
                    width="60px"
                  />
                </h3>
                <p>
                  Sus vestigios medievales y el serpenteo de las aguas del Lozoya hacen de Buitrago un lugar único.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="6h" />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta8/el-paular.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3 d-flex align-items-center">
                  <span>Rascafría</span>
                  <img
                    class="ml-3"
                    src="/img/logos/logo-villas-de-madrid-circular.png"
                    alt="Villas de Madrid"
                    width="60px"
                  />
                </h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/rascafria"
                        target="_blank"
                        alt="Más información sobre Rascafría"
                        >En este pueblito de cuento,</a
                      >
                      que debe su nombre a la frialdad de sus inviernos, te recomendamos que visites su Ayuntamiento de
                      estilo neomudéjar, el puente de Pericotón y la Plaza de la Villa. ¡Y
                      <strong
                        >apenas a dos kilómetros del centro del pueblo tienes el Monasterio de Santa María de El
                        Paular!</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      Rascafría <strong>también destaca por sus enclaves naturales:</strong> piérdete en el Bosque de
                      Finlandia, refréscate en las Presillas de Rascafría (con unas increíbles vistas del Peñalara) o
                      haz una ruta hasta la Cascada del Purgatorio.
                    </span>
                  </li>

                  <li>
                    <span>
                      Y no olvides visitar su obrador de chocolate natural. ¡Una auténtica delicia para los más golosos!
                    </span>
                  </li>
                  <li>
                    <span>
                      ¡Se trata de
                      <strong>una de las opciones de turismo más versátiles de la Comunidad de Madrid!</strong>
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="5h" />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3 d-flex align-items-center">
                  <span>Rascafría</span>
                  <img
                    class="ml-3"
                    src="/img/logos/logo-villas-de-madrid-circular.png"
                    alt="Villas de Madrid"
                    width="60px"
                  />
                </h3>
                <p>
                  Arquitectura, naturaleza, deportes… ¡Una de las localizaciones más versátiles de la Comunidad de
                  Madrid!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="5h" />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta8/la-hiruela.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">La Hiruela</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/la-hiruela"
                        target="_blank"
                        alt="Más información sobre la Hiruela"
                        >Este pequeño pueblo</a
                      >
                      fue
                      <strong
                        >uno de los 10 pueblos finalistas para convertirse en Capital del Turismo Rural de España en
                        2019.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      En el centro del pueblo
                      <strong
                        >te recomendamos que visites la Iglesia de San Miguel Arcángel y su Museo Etnológico.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      También <strong>puedes hacer la ruta “de molino a molino”,</strong> una actividad de dificultad
                      moderada, perfecta para los amantes de la naturaleza.
                    </span>
                  </li>
                  <li>
                    <span>
                      En esta zona es <strong>especialmente recomendable comer judiones,</strong> ¡uno de los
                      ingredientes básicos de cualquier plato de cuchara de la Sierra Norte de Madrid!</span
                    >
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">La Hiruela</h3>
                <p>
                  Pasear por las hermosas calles de La Hiruela, donde reina la calma, te hará vivir Madrid de un modo
                  asombroso.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta3/hayedo.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Hayedo de Montejo</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¡Uno de los emplazamientos naturales más bonitos y sorprendentes de la Comunidad de Madrid!
                      <a
                        href="https://www.sierranortemadrid.org/planes/hayedo-montejo"
                        target="_blank"
                        alt="Más información sobre el Hayedo de Montejo"
                        >El Hayedo de Montejo</a
                      >
                      ha sido declarado Sitio Natural de Interés Nacional, ya que se trata de
                      <strong>uno de los bosques de hayas más meridionales de Europa.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Para obtener un “pase de día” debes dirigirte al Centro de Información de la Reserva de la
                      Biosfera de la Sierra del Rincón, en Montejo de la Sierra; o reservar online el día 1 y 16 de cada
                      mes. ¡Corre, que vuelan!
                    </span>
                  </li>
                  <li>
                    <span>
                      Aunque el otoño es una de las estaciones más bonitas para verlo, suele ser complicado hacerlo por
                      la gran afluencia de visitas que recibe, por lo que recomendamos la primavera.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-otono />
                  <icon-primavera />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Hayedo de Montejo</h3>

                <p>
                  Uno de los lugares más fascinantes de la Sierra Norte de Madrid: ¡naturaleza en estado puro!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-otono />
                  <icon-primavera />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Patones de Arriba (Villa de Madrid)">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/de-la-arquitectura-a-la-mesa/"
                  target="_blank"
                  alt="Más información sobre Patones de Arriba"
                  >¡Uno de los pueblos más pintorescos de la Comunidad de Madrid!</a
                >
                Todas las casas del pueblo están hechas de piedra, por lo que es un
                <strong>fiel representante de la arquitectura típica local.</strong>
              </span>
            </li>
            <li>
              <span> Si tienes tiempo puedes visitar <strong>La presa del Pontón de la Oliva.</strong> </span>
            </li>
            <li>
              <span>
                Consejos adicionales: Si quieres ir a verlo en fin de semana o festivo, reserva antes en algún
                restaurante para comer, porque suelen llenarse; No está permitido aparcar en Patones de Arriba. Puedes
                hacerlo en Patones de Abajo y subir caminando por la Senda del Barranco. ¡Solo te llevará 10 o 15
                minutos de agradable paseo!
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Buitrago de Lozoya (Villa de Madrid)">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/planes/visitas-buitrago"
                  target="_blank"
                  alt="Más información sobre Buitrago de Lozaya"
                  >Buitrago</a
                >
                se alza sobre un promontorio circundado por el río Lozoya, del que toma parte de su nombre, y
                <strong>destaca por la muralla que rodea su centro histórico.</strong> Además, su Castillo o Alcázar, la
                iglesia de Santa María del Castillo, la Torre del Reloj y la propia muralla te trasladarán hasta la Edad
                Media.
              </span>
            </li>
            <li>
              <span>
                ¿Sabías que en Buitrago del Lozoya puedes visitar un
                <strong>museo dedicado a Pablo Picasso,</strong> con 65 obras del pintor malagueño?
              </span>
            </li>

            <li>
              <span>
                Muy cerca de Buitrago puedes disfrutar de un entorno natural privilegiado: ¿has visitado ya las
                <strong>piscinas naturales de Riosequillo?</strong>
              </span>
            </li>
            <li>
              <span>
                Consejo adicional: es posible llegar en transporte público (autobús desde Plaza Castilla. Línea 191).
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Rascafría (Villa de Madrid)">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/rascafria"
                  target="_blank"
                  alt="Más información sobre Rascafría"
                  >En este pueblito de cuento,</a
                >
                que debe su nombre a la frialdad de sus inviernos, te recomendamos que visites su Ayuntamiento de estilo
                neomudéjar, el puente de Pericotón y la Plaza de la Villa. ¡Y
                <strong
                  >apenas a dos kilómetros del centro del pueblo tienes el Monasterio de Santa María de El
                  Paular!</strong
                >
              </span>
            </li>
            <li>
              <span>
                Rascafría <strong>también destaca por sus enclaves naturales:</strong> piérdete en el Bosque de
                Finlandia, refréscate en las Presillas de Rascafría (con unas increíbles vistas del Peñalara) o haz una
                ruta hasta la Cascada del Purgatorio.
              </span>
            </li>

            <li>
              <span>
                Y no olvides visitar su obrador de chocolate natural. ¡Una auténtica delicia para los más golosos!
              </span>
            </li>
            <li>
              <span>
                ¡Se trata de
                <strong>una de las opciones de turismo más versátiles de la Comunidad de Madrid!</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="La Hiruela">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/la-hiruela"
                  target="_blank"
                  alt="Más información sobre la Hiruela"
                  >Este pequeño pueblo</a
                >
                fue
                <strong
                  >uno de los 10 pueblos finalistas para convertirse en Capital del Turismo Rural de España en
                  2019.</strong
                >
              </span>
            </li>
            <li>
              <span>
                En el centro del pueblo
                <strong>te recomendamos que visites la Iglesia de San Miguel Arcángel y su Museo Etnológico.</strong>
              </span>
            </li>
            <li>
              <span>
                También <strong>puedes hacer la ruta “de molino a molino”,</strong> una actividad de dificultad
                moderada, perfecta para los amantes de la naturaleza.
              </span>
            </li>
            <li>
              <span>
                En esta zona es <strong>especialmente recomendable comer judiones,</strong> ¡uno de los ingredientes
                básicos de cualquier plato de cuchara de la Sierra Norte de Madrid!</span
              >
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Hayedo de Montejo">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¡Uno de los emplazamientos naturales más bonitos y sorprendentes de la Comunidad de Madrid!
                <a
                  href="https://www.sierranortemadrid.org/planes/hayedo-montejo"
                  target="_blank"
                  alt="Más información sobre el Hayedo de Montejo"
                  >El Hayedo de Montejo</a
                >
                ha sido declarado Sitio Natural de Interés Nacional, ya que se trata de
                <strong>uno de los bosques de hayas más meridionales de Europa.</strong>
              </span>
            </li>
            <li>
              <span>
                Para obtener un “pase de día” debes dirigirte al Centro de Información de la Reserva de la Biosfera de
                la Sierra del Rincón, en Montejo de la Sierra; o reservar online el día 1 y 16 de cada mes. ¡Corre, que
                vuelan!
              </span>
            </li>
            <li>
              <span>
                Aunque el otoño es una de las estaciones más bonitas para verlo, suele ser complicado hacerlo por la
                gran afluencia de visitas que recibe, por lo que recomendamos la primavera.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    // IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    // IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    // IconFamilias: () => import('../../components/iconos/IconFamilias'),
    // IconFoodies: () => import('../../components/iconos/IconFoodies'),
    // IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    // IconInvierno: () => import('../../components/iconos/IconInvierno'),
    IconOtono: () => import('../../components/iconos/IconOtono'),
    // IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones')
    // IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-40%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setTween('#fondo-puntos', {
          width: '50%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
